import dispatcher from "../Dispatcher";
import actionTypes from "./ActionTypes";
import axios from "axios";
import * as Globals from "../Globals";
import { Logout } from "./LoginActions";
import { PostAlert } from "./AlertActions";
export function AddAICaptureGenericField(newField) {
  axios.post(`${Globals.baseUrl}/AICapture/AddAICaptureGenericField`, newField, {
    headers: {
      "content-type": "application/json; charset=utf-8",
      Authorization: `Bearer ${Globals.getJwtToken()}`
    }
  }).then((res) => {
    if (res.status === 200) {
      dispatcher.dispatch({
        actionType: actionTypes.AddAICaptureGenericField,
        Result: res.data
      });
      PostAlert("success", "AI Field added");
    } else if (res.status === 400 || res.status === 401) {
      Logout();
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      Logout();
    } else {
      PostAlert("error", "Unable to add AI field");
      console.log("Request failed:", error);
    }
  });
}
export function DeleteAICaptureGenericField(id) {
  axios.delete(`${Globals.baseUrl}/AICapture/DeleteAICaptureGenericField/${id}`, {
    headers: {
      "content-type": "application/json; charset=utf-8",
      Authorization: `Bearer ${Globals.getJwtToken()}`
    }
  }).then((res) => {
    if (res.status === 200) {
      dispatcher.dispatch({
        actionType: actionTypes.DeleteAICaptureGenericField
      });
      PostAlert("success", "AI Field deleted");
    } else if (res.status === 400 || res.status === 401) {
      Logout();
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      Logout();
    } else {
      PostAlert("error", "Unable to delete AI field");
      console.log("Request failed:", error);
    }
  });
}
export function UpdateAICaptureFields(payload) {
  axios.post(`${Globals.baseUrl}/AICapture/UpdateAICaptureFields`, payload, {
    headers: {
      "content-type": "application/json; charset=utf-8",
      Authorization: `Bearer ${Globals.getJwtToken()}`
    }
  }).then((res) => {
    if (res.status === 200) {
      dispatcher.dispatch({
        actionType: actionTypes.UpdateAICaptureFields
      });
      PostAlert("success", "AI Field updated");
    } else if (res.status === 400 || res.status === 401) {
      Logout();
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      Logout();
    } else {
      PostAlert("error", "Unable to update AI field");
      console.log("Request failed:", error);
    }
  });
}
export function GetAICaptureFields(genericFieldId) {
  axios.get(`${Globals.baseUrl}/AICapture/GetAICaptureFields/${genericFieldId}`, {
    headers: {
      "content-type": "application/json; charset=utf-8",
      Authorization: `Bearer ${Globals.getJwtToken()}`
    }
  }).then((res) => {
    if (res.status === 200) {
      dispatcher.dispatch({
        actionType: actionTypes.GetAICaptureFields,
        Result: res.data
      });
    } else if (res.status === 400 || res.status === 401) {
      Logout();
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
export function GetCurrentMonthRequestCount() {
  axios.get(`${Globals.baseUrl}/AICapture/GetCurrentMonthRequestCount`, {
    headers: {
      "content-type": "application/json; charset=utf-8",
      Authorization: `Bearer ${Globals.getJwtToken()}`
    }
  }).then((res) => {
    if (res.status === 200) {
      dispatcher.dispatch({
        actionType: actionTypes.GetAICaptureCurrentMonthRequestCount,
        Result: res.data
      });
    } else if (res.status === 400 || res.status === 401) {
      Logout();
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
export function GetAICaptureGenericFields() {
  axios.get(`${Globals.baseUrl}/AICapture/GetAICaptureGenericFields`, {
    headers: {
      "content-type": "application/json; charset=utf-8",
      Authorization: `Bearer ${Globals.getJwtToken()}`
    }
  }).then((res) => {
    console.log("retrurnable");
    if (res.status === 200) {
      dispatcher.dispatch({
        actionType: actionTypes.GetAICaptureGenericFields,
        Result: res.data
      });
    } else if (res.status === 400 || res.status === 401) {
      Logout();
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      console.log("error: 401. Logging user out...");
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
